export default __webpack_public_path__ + "static/media/user.79997b57.svg";